import(/* webpackMode: "eager", webpackExports: ["MlbTeamListClient"] */ "/Users/yk/Dev/BaseballDataViewer/nextjs/components/client/HomeClient.tsx");
